import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-underutilization-form',
  standalone: false,
  templateUrl: './underutilization-form.component.html',
  styleUrl: './underutilization-form.component.scss'
})
export class UnderutilizationFormComponent implements OnInit {

  ngOnInit(): void {
    
  }

}
